import type { EntityConfig } from '../types'

export const rewardEntity: EntityConfig = {
  id: 'reward',
  displayName: 'Reward',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'draft', label: 'Draft' },
      { value: 'active', label: 'Active' },
      { value: 'inactive', label: 'Inactive' },
      { value: 'archived', label: 'Archived' },
    ],
    options: [
      { value: 'draft', label: 'Draft', color: 'neutral' },
      { value: 'active', label: 'Active', color: 'success' },
      { value: 'inactive', label: 'Inactive', color: 'warning' },
      { value: 'archived', label: 'Archived', color: 'neutral' },
    ],
    mappings: {
      all: ['draft', 'active', 'inactive', 'archived'],
      active: ['active'],
      draft: ['draft'],
      inactive: ['inactive'],
      archived: ['archived'],
    },
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    mechanic: { type: 'string_array', urlKey: 'mechanic' },
    search: { type: 'search', urlKey: '$s' },
  },
  uiFilterFields: ['status', 'mechanic'],
}
